<template>
  <div class="login">
    <section class="left-panel">
      <header>
        <div class="grid-container top">
          <div class="col-4">
            <img class="logo" src="../assets/images/global/logo.svg">
          </div>
        </div>
      </header>
      <div class="grid-container">
        <div class="col-4 vertical-centre">
          <div class="left-panel-centre">
            <h1>Logging out...</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="hero-image">
    </section>
  </div>
</template>

<script>
import { auth } from '@/firebase'
import router from '@/router'

export default {
  methods: {
    logout () {
      auth.signOut().then(function () {
        localStorage.clear()
        // Sign-out successful.
        console.log('Logged out')
        setTimeout(function () {
          router.push('/login') // Redirect to login page after 2 seconds
        }, 1000)
      }, function (error) {
        // An error happened.
        console.error(error)
      })
    }
  },
  mounted () {
    this.logout() // Run the script
  }
}
</script>



// WEBPACK FOOTER //
// Logout.vue?15ddca1e